export default __webpack_public_path__ + "static/media/bg-layer-2.ad29fd9f.svg";